<template>
    <div>
        <div class="user-form">
            <form class="form-horizontal form-w8 form-c200">
                <div class="form-group" :class="{'has-error':errors.has('oldPassword')}">
                    <label class="control-label">旧密码：</label>
                    <div class="controls">
                        <input name="oldPassword" v-validate="rules.oldPassword" class="form-control" type="password"
                               v-model="model.oldPassword">
                        <span v-show="errors.has('oldPassword')" class="error-message">{{ errors.first('oldPassword') }}</span>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error':errors.has('newPassword')}">
                    <label class="control-label">新密码：</label>
                    <div class="controls">
                        <input name="newPassword" class="form-control" type="password"
                               v-validate="'newPassword'"
                               v-model="model.newPassword">
                        <span v-show="errors.has('newPassword')" class="error-message">{{ errors.first('newPassword') }}</span>
                        <br>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error':errors.has('newPassword1')}">
                    <label class="control-label">确认新密码：</label>
                    <div class="controls">
                        <input name="newPassword1" class="form-control" type="password"
                               v-validate="'newPassword1'"
                               v-model="model.newPassword1">
                        <span v-show="errors.has('newPassword1')" class="error-message">{{ errors.first('newPassword1') }}</span>
                        <br>
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label"></label>
                    <div class="controls form-op">
                        <button type="button" class="btn btn-primary" @click="onSubmit">
                            提交
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<style lang="scss" rel="stylesheet/scss" scoped>
    .el-dialog__body {
        padding-top: 0px;
    }

</style>
<script type="text/ecmascript-6">
    import mixin from '../mixin';
    import store, {types as storeTypes} from '../../vuex'

    export default {
        mixins: [mixin],
        props: {
            value: Object
        },
        data() {
            //必须要有这些字段, vue的双向绑定才不会有问题
            let model = Object.assign({
                oldPassword: '',
                newPassword: '',
                newPassword1: '',
            }, this.value || {});

            return {
                model,
                tipPwd: false,
                rules: {
                    oldPassword: {
                        required: {
                            message: "请输入旧密码"
                        }
                    }
                }
            }
        },
        mounted() {
            this.$validator.extend('newPassword', {
                validate: value => {
                    let test1 = /[a-zA-Z]/.test(value);
                    let test2 = /[0-9]/.test(value);
                    return value.length >= 6 && test1 && test2;
                },
                getMessage: () => {
                    return "必须包含数字和字母，长度至少6位";
                }
            });
            this.$validator.extend('newPassword1', {
                validate: value => {
                    let test1 = /[a-zA-Z]/.test(value);
                    let test2 = /[0-9]/.test(value);
                    return value.length >= 6 && test1 && test2;
                },
                getMessage: () => {
                    return "必须包含数字和字母，长度至少6位";
                }
            });
        },
        methods: {
            onSubmit() {
                console.log(this.model);
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }
                    if(!this.model.newPassword || !this.model.newPassword1){
                        return;
                    }
                    if(this.model.newPassword != this.model.newPassword1){
                        this.$layer.alert("两次输入密码不一致，请确认输入");
                        return;
                    }
                    this.$http
                        .post('/api/user/updatePwd', this.model)
                        .then(({data}) => {
                            if (data.success) {
                                this.$layer.success('修改成功');
                                store.commit(storeTypes.SET_USER, data.data);
                                this.$emit('confirm');
                            } else {
                                this.$layer.alert(data.errorMsg)
                            }
                        });
                });
            },
            onCancel() {
                this.$emit('close');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/account/ChangePassword.vue